module.exports = __webpack_public_path__ + "static/media/card-pay.9c4d35c5.jpg";